import SearchableSingleValueSelect from "components/searchable-series-select/searchable-single-value-select";
import { fetchFilesTypes } from "services/files-types.service";

interface SearchableFilesTypesSelectProps {
  value: string;
  onChange: (value: string) => void;
  isRequired?: boolean;
  disabled?: boolean;
}

const mapFileTypeOption = (row: any) => ({
  label: row.label,
  value: row.id,
});

export default function SearchableFilesTypesSelect({
  value,
  onChange,
  isRequired = false,
  disabled = false,
}: SearchableFilesTypesSelectProps) {
  return (
    <SearchableSingleValueSelect
      value={value}
      onChange={onChange}
      isRequired={isRequired}
      disabled={disabled}
      labelKey="files_types_select"
      requiredErrorKey="file_type_is_required"
      fetchOptions={fetchFilesTypes}
      mapOption={mapFileTypeOption}
    />
  );
}
